// TZ-684 -- turns an internal path into its equivalent in a given language.
//
// The site has 147 <Link to="..."> elements and, before this, every one of them
// pointed at the Polish version. A patient who landed on /en/ was thrown back
// to Polish by their first click: the English translation was reachable only
// through the switcher, and only for a single page view.
//
// 🔴 THE COVERAGE CHECK IS THE POINT OF THIS FUNCTION. COVERAGE lists 25
// translated paths. /czerniak, /cennik, /o-nas, /quiz and every /blog/* are
// NOT among them. Blindly prefixing would turn 66 language-losing links into
// 66 links to 404 pages -- trading a flaw for an outage. A link to an
// untranslated page deliberately stays Polish: an English reader reaches a
// Polish page that exists rather than an error page. Not ideal; the ideal is
// to translate those pages. Honest until then.
const {
  DEFAULT_LANGUAGE,
  buildLanguagePath,
  hasLanguage,
} = require("./i18nCoverage")

// Anything with a scheme, or protocol-relative, leaves our site.
const isExternal = (to) => /^([a-z][a-z0-9+.-]*:|\/\/)/i.test(to)

const localizePath = (to, language) => {
  if (!to) return to
  if (isExternal(to)) return to
  // A bare fragment stays on the current page, whatever language that is.
  if (to.startsWith("#")) return to
  if (language === DEFAULT_LANGUAGE) return to

  // Split off #fragment and ?query: coverage is a property of the PATH.
  // Judging it on the whole string would make /kontakt#form look untranslated.
  const boundary = to.search(/[?#]/)
  const path = boundary === -1 ? to : to.slice(0, boundary)
  const suffix = boundary === -1 ? "" : to.slice(boundary)

  if (!hasLanguage(path, language)) return to

  return `${buildLanguagePath(path, language)}${suffix}`
}

module.exports = { localizePath }
